export default {
    VALOR: {texto: 'Valor (R$)', valor: 'VALOR'},
    PERCENTUAL: {texto: 'Percentual (%)', valor: 'PERCENTUAL'},
}
